import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CalendarClock, Bell, Mail } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const fmt = (n) => Number(n || 0).toLocaleString('fr-CA');

const Choice = ({ active, onClick, icon: Icon, children, testId }) => (
  <button onClick={onClick} data-testid={testId}
    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors ${active ? 'bg-amber-500 text-black' : 'bg-slate-800 text-slate-300 hover:bg-slate-700'}`}>
    <Icon size={13} /> {children}
  </button>
);

export const KmSummaryCard = ({ token }) => {
  const [data, setData] = useState(null);
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    axios.get(`${API}/api/analytics/km-summary`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setData(r.data)).catch(() => {});
  }, [token]);

  const choose = async (delivery) => {
    try {
      await axios.put(`${API}/api/analytics/km-summary`, { delivery }, { headers });
      setData(d => ({ ...d, delivery }));
      toast.success(delivery === 'email' ? 'Résumé mensuel : notification + courriel' : 'Résumé mensuel : notification seulement');
    } catch { toast.error('Erreur'); }
  };

  if (!data) return null;
  const total = (t) => data.rows.filter(r => r.type === t && (r.owner || 'own') === 'own').reduce((s, r) => s + r.km, 0);

  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-4 flex flex-wrap items-center justify-between gap-3" data-testid="km-summary-card">
      <div>
        <p className="text-white font-semibold text-sm flex items-center gap-2"><CalendarClock size={16} className="text-amber-500" /> Résumé mensuel des km</p>
        <p className="text-xs text-slate-400 mt-1" data-testid="km-summary-last-month">
          Envoyé le 1er de chaque mois. {data.month} (ma flotte) : camions {fmt(total('camion'))} km · remorques {fmt(total('remorque'))} km
        </p>
      </div>
      <div className="flex items-center gap-2">
        <Choice active={data.delivery === 'notification'} onClick={() => choose('notification')} icon={Bell} testId="km-summary-notification">Notification seulement</Choice>
        <Choice active={data.delivery === 'email'} onClick={() => choose('email')} icon={Mail} testId="km-summary-email">Notification + courriel</Choice>
      </div>
    </div>
  );
};
